(function (factory) {

    if (typeof define === 'function' && define.amd) {

        // AMD. Register as an anonymous module.
        define([], factory);

    } else if (typeof exports === 'object') {

        // Node/CommonJS
        module.exports = factory();

    } else {

        // Browser globals
        window.wNumb = factory();
    }

}(function () {

    'use strict';

    var FormatOptions = [
        'decimals',
        'thousand',
        'mark',
        'prefix',
        'suffix',
        'encoder',
        'decoder',
        'negativeBefore',
        'negative',
        'edit',
        'undo'
    ];

    // General

    // Reverse a string
    function strReverse(a) {
        return a.split('').reverse().join('');
    }

    // Check if a string starts with a specified prefix.
    function strStartsWith(input, match) {
        return input.substring(0, match.length) === match;
    }

    // Check is a string ends in a specified suffix.
    function strEndsWith(input, match) {
        return input.slice(-1 * match.length) === match;
    }

    // Throw an error if formatting options are incompatible.
    function throwEqualError(F, a, b) {
        if ((F[a] || F[b]) && (F[a] === F[b])) {
            throw new Error(a);
        }
    }

    // Check if a number is finite and not NaN
    function isValidNumber(input) {
        return typeof input === 'number' && isFinite(input);
    }

    // Provide rounding-accurate toFixed method.
    // Borrowed: http://stackoverflow.com/a/21323330/775265
    function toFixed(value, exp) {
        value = value.toString().split('e');
        value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));
        value = value.toString().split('e');
        return (+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp))).toFixed(exp);
    }


    // Formatting

    // Accept a number as input, output formatted string.
    function formatTo(decimals, thousand, mark, prefix, suffix, encoder, decoder, negativeBefore, negative, edit, undo, input) {

        var originalInput = input, inputIsNegative, inputPieces, inputBase, inputDecimals = '', output = '';

        // Apply user encoder to the input.
        // Expected outcome: number.
        if (encoder) {
            input = encoder(input);
        }

        // Stop if no valid number was provided, the number is infinite or NaN.
        if (!isValidNumber(input)) {
            return false;
        }

        // Rounding away decimals might cause a value of -0
        // when using very small ranges. Remove those cases.
        if (decimals !== false && parseFloat(input.toFixed(decimals)) === 0) {
            input = 0;
        }

        // Formatting is done on absolute numbers,
        // decorated by an optional negative symbol.
        if (input < 0) {
            inputIsNegative = true;
            input = Math.abs(input);
        }

        // Reduce the number of decimals to the specified option.
        if (decimals !== false) {
            input = toFixed(input, decimals);
        }

        // Transform the number into a string, so it can be split.
        input = input.toString();

        // Break the number on the decimal separator.
        if (input.indexOf('.') !== -1) {
            inputPieces = input.split('.');

            inputBase = inputPieces[0];

            if (mark) {
                inputDecimals = mark + inputPieces[1];
            }

        } else {

            // If it isn't split, the entire number will do.
            inputBase = input;
        }

        // Group numbers in sets of three.
        if (thousand) {
            inputBase = strReverse(inputBase).match(/.{1,3}/g);
            inputBase = strReverse(inputBase.join(strReverse(thousand)));
        }

        // If the number is negative, prefix with negation symbol.
        if (inputIsNegative && negativeBefore) {
            output += negativeBefore;
        }

        // Prefix the number
        if (prefix) {
            output += prefix;
        }

        // Normal negative option comes after the prefix. Defaults to '-'.
        if (inputIsNegative && negative) {
            output += negative;
        }

        // Append the actual number.
        output += inputBase;
        output += inputDecimals;

        // Apply the suffix.
        if (suffix) {
            output += suffix;
        }

        // Run the output through a user-specified post-formatter.
        if (edit) {
            output = edit(output, originalInput);
        }

        // All done.
        return output;
    }

    // Accept a sting as input, output decoded number.
    function formatFrom(decimals, thousand, mark, prefix, suffix, encoder, decoder, negativeBefore, negative, edit, undo, input) {

        var originalInput = input, inputIsNegative, output = '';

        // User defined pre-decoder. Result must be a non empty string.
        if (undo) {
            input = undo(input);
        }

        // Test the input. Can't be empty.
        if (!input || typeof input !== 'string') {
            return false;
        }

        // If the string starts with the negativeBefore value: remove it.
        // Remember is was there, the number is negative.
        if (negativeBefore && strStartsWith(input, negativeBefore)) {
            input = input.replace(negativeBefore, '');
            inputIsNegative = true;
        }

        // Repeat the same procedure for the prefix.
        if (prefix && strStartsWith(input, prefix)) {
            input = input.replace(prefix, '');
        }

        // And again for negative.
        if (negative && strStartsWith(input, negative)) {
            input = input.replace(negative, '');
            inputIsNegative = true;
        }

        // Remove the suffix.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/slice
        if (suffix && strEndsWith(input, suffix)) {
            input = input.slice(0, -1 * suffix.length);
        }

        // Remove the thousand grouping.
        if (thousand) {
            input = input.split(thousand).join('');
        }

        // Set the decimal separator back to period.
        if (mark) {
            input = input.replace(mark, '.');
        }

        // Prepend the negative symbol.
        if (inputIsNegative) {
            output += '-';
        }

        // Add the number
        output += input;

        // Trim all non-numeric characters (allow '.' and '-');
        output = output.replace(/[^0-9\.\-.]/g, '');

        // The value contains no parse-able number.
        if (output === '') {
            return false;
        }

        // Covert to number.
        output = Number(output);

        // Run the user-specified post-decoder.
        if (decoder) {
            output = decoder(output);
        }

        // Check is the output is valid, otherwise: return false.
        if (!isValidNumber(output)) {
            return false;
        }

        return output;
    }


    // Framework

    // Validate formatting options
    function validate(inputOptions) {

        var i, optionName, optionValue,
			filteredOptions = {};

        if (inputOptions['suffix'] === undefined) {
            inputOptions['suffix'] = inputOptions['postfix'];
        }

        for (i = 0; i < FormatOptions.length; i += 1) {

            optionName = FormatOptions[i];
            optionValue = inputOptions[optionName];

            if (optionValue === undefined) {

                // Only default if negativeBefore isn't set.
                if (optionName === 'negative' && !filteredOptions.negativeBefore) {
                    filteredOptions[optionName] = '-';
                    // Don't set a default for mark when 'thousand' is set.
                } else if (optionName === 'mark' && filteredOptions.thousand !== '.') {
                    filteredOptions[optionName] = '.';
                } else {
                    filteredOptions[optionName] = false;
                }

                // Floating points in JS are stable up to 7 decimals.
            } else if (optionName === 'decimals') {
                if (optionValue >= 0 && optionValue < 8) {
                    filteredOptions[optionName] = optionValue;
                } else {
                    throw new Error(optionName);
                }

                // These options, when provided, must be functions.
            } else if (optionName === 'encoder' || optionName === 'decoder' || optionName === 'edit' || optionName === 'undo') {
                if (typeof optionValue === 'function') {
                    filteredOptions[optionName] = optionValue;
                } else {
                    throw new Error(optionName);
                }

                // Other options are strings.
            } else {

                if (typeof optionValue === 'string') {
                    filteredOptions[optionName] = optionValue;
                } else {
                    throw new Error(optionName);
                }
            }
        }

        // Some values can't be extracted from a
        // string if certain combinations are present.
        throwEqualError(filteredOptions, 'mark', 'thousand');
        throwEqualError(filteredOptions, 'prefix', 'negative');
        throwEqualError(filteredOptions, 'prefix', 'negativeBefore');

        return filteredOptions;
    }

    // Pass all options as function arguments
    function passAll(options, method, input) {
        var i, args = [];

        // Add all options in order of FormatOptions
        for (i = 0; i < FormatOptions.length; i += 1) {
            args.push(options[FormatOptions[i]]);
        }

        // Append the input, then call the method, presenting all
        // options as arguments.
        args.push(input);
        return method.apply('', args);
    }

    function wNumb(options) {

        if (!(this instanceof wNumb)) {
            return new wNumb(options);
        }

        if (typeof options !== "object") {
            return;
        }

        options = validate(options);

        // Call 'formatTo' with proper arguments.
        this.to = function (input) {
            return passAll(options, formatTo, input);
        };

        // Call 'formatFrom' with proper arguments.
        this.from = function (input) {
            return passAll(options, formatFrom, input);
        };
    }

    return wNumb;

}));

$(document).ready(function () {

    jQuery.fn.exists = function () { return jQuery(this).length > 0; };

    jQuery.fn.insertHidden = function (name, value) {
        var t = jQuery(this);
        var input = $("<input type='hidden' />");
        input.attr('name', name);
        input.val(value);
        t.append(input);
    };

    jQuery.fn.float = function (value) {
        if (value) {
            return jQuery(this).html(value.toFixed(2).replace(".", ","));
        }
        else {
            var result = 0;
            jQuery(this).each(function () {
                var input = jQuery(this);
                var txt;
                if (input.is(":input"))
                    txt = input.val();
                else
                    txt = input.html().replace("&nbsp;", "");
                var fl = parseFloat(txt.replace(",", "."));
                if (!isNaN(fl))
                    result += fl;
            });
            return result;
        }
    };

    jQuery.fn.id = function () { return jQuery(this).attr("id"); };
    jQuery.fn.rel = function () { return jQuery(this).attr("rel"); };

    jQuery.fn.checked = function () { return jQuery(this).is(":checked"); };

    jQuery.fn.check = function () { return jQuery(this).attr("checked", "checked"); };
    jQuery.fn.uncheck = function () { return jQuery(this).attr("checked", ""); };

    jQuery.fn.values = function () {
        var result = [];
        $(this).each(function () {
            result.push($(this).val());
        });
        return result;
    };

    $.expr[":"].econtains = function (obj, index, meta) {
        return (obj.textContent || obj.innerText || $(obj).text() || "").toLowerCase() == meta[3].toLowerCase();
    };

    jQuery.fn.toCSV = function () {
        var data = $(this).first();
        var csvData = [];
        var tmpArr = [];
        var tmpStr = '';
        data.find("tr").each(function () {
            if ($(this).find("th").length) {
                $(this).find("th").each(function () {
                    tmpStr = $(this).text().trim().replace(/"/g, '""');
                    tmpArr.push('"' + tmpStr + '"');
                });
                csvData.push(tmpArr.join(';'));
            } else {
                tmpArr = [];
                $(this).find("td").each(function () {
                    tmpStr = $(this).text().trim().replace(/"/g, '""');
                    tmpStr = tmpStr.replace(/ +/g, ' ').replace(/(\r\n|\n|\r)/gm, "");
                    if (!isNaN(tmpStr.replace(/\s/g, '').replace(",", ".")))
                        tmpArr.push('"' + tmpStr.replace(/\s/g, '') + '"');
                    else
                        tmpArr.push('"' + tmpStr + '"');
                });
                csvData.push(tmpArr.join(';'));
            }
        });
        return csvData.join('\n');
    }

    jQuery.fn.toHeaderCSV = function () {        
        var tmpStr = $(this).html();
        tmpStr = tmpStr.replace(/[\r\n]/g, '');
        tmpStr = "<header>" + tmpStr + "</header>";

        return tmpStr;
    }



    String.prototype.replaceAll = function (search, replacement) {
        var target = this;
        return target.split(search).join(replacement);
    };
});

function escapeRegExp(string) {
    return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}

function replaceAll(string, find, replace) {
    return string.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}


function validatedate(inputText) {
    var dateformat = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])( ((0?[0-9]|1[0-9]|2[0123])(:([0-5][0-9])){2})| ((0?[0-9]|1[0-2])(:([0-5][0-9])){2}) (AM|PM))?$/gm;
    // Match the date format through regular expression
    if((m = dateformat.exec(inputText)) !== null && !!inputText) {
      //document.form1.text1.focus();
      //Test which seperator is used '/' or '-'
      var opera1 = inputText.split('/');
      var opera2 = inputText.split('-');
      lopera1 = opera1.length;
      lopera2 = opera2.length;
      // Extract the string into month, date and year
      if (lopera1>1) {
        var pdate = inputText.split('/');
      } else if (lopera2>1) {
        var pdate = inputText.split('-');
      }
      var mm  = parseInt(pdate[0]);
      var dd = parseInt(pdate[1]);
      var yy = parseInt(pdate[2]);
      // Create list of days of a month [assume there is no leap year by default]
      var ListofDays = [31,28,31,30,31,30,31,31,30,31,30,31];
      if (mm==1 || mm>2) {
        if (dd>ListofDays[mm-1]) {
          console.log('Invalid date format! 1');
          return false;
        }
      }
      if (mm==2) {
        var lyear = false;
        if ( (!(yy % 4) && yy % 100) || !(yy % 400)) {
          lyear = true;
        }
        if ((lyear==false) && (dd>=29)) {
          console.log('Invalid date format! 2');
          return false;
        }
        if ((lyear==true) && (dd>29)) {
          console.log('Invalid date format! 3');
          return false;
        }
        }
    } else if (inputText == '--') {
        return true;
    } else if (inputText) {
      console.log("Invalid date format! 4");
      // document.form1.text1.focus();
      return false;
    }
    
    console.log("Valid!");
    return true;
  }
  
  
  jQuery.validator.methods["date"] = function (value, element) { 
    return validatedate(value);
} 


function getCookieValue2(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");

    if (parts.length == 2) {
        return parts.pop().split(";").shift();
    }
}

function getLanguage() {
    var culture = getCookieValue2("_culture");

    if (culture) {
        var splited = culture.split('-');

        return splited[0];
    }

    return "en"
}
